import { Refresh } from "@/components/icons";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect } from "react";
import { toast } from "@/hooks/use-toast";

const SYNC_SUCCESS_KEY = "pwa-sync-success";

const Syncronization = () => {
  const { t } = useTranslation();

  useEffect(() => {
    if (sessionStorage.getItem(SYNC_SUCCESS_KEY)) {
      sessionStorage.removeItem(SYNC_SUCCESS_KEY);
      toast({
        title: t("success_message.title"),
        description: t("success_message.synchronization_description"),
      });
    }
  }, [t]);

  const handleSync = useCallback(async () => {
    try {
      if ("serviceWorker" in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        if (reg) await reg.update();
      }
      sessionStorage.setItem(SYNC_SUCCESS_KEY, "1");
      window.location.reload();
    } catch {
      sessionStorage.setItem(SYNC_SUCCESS_KEY, "1");
      window.location.reload();
    }
  }, []);

  return (
    <button
      type="button"
      onClick={handleSync}
      className="flex w-full flex-row items-center justify-between px-5 py-[15px] text-left"
    >
      <div className="flex flex-row items-center gap-2 text-white">
        <Refresh />
        <span className="font-base font-medium">
          {t("label.synchronization")}
        </span>
      </div>
    </button>
  );
};

export default Syncronization;
